import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import timesheetLogo from '../../assets/images/timesheet-logo.png';
import {
  FaHome,
  FaClock,
  FaMoneyBill,
  FaCog,
  FaQuestionCircle,
  FaFileAlt,
  FaClipboardCheck,
} from 'react-icons/fa';
import { useSidebar } from './SidebarContext';
import './LayoutComponents.css';

const Sidebar = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const { isOpen, close } = useSidebar();
  const location = useLocation();

  const isApprover = user?.roles?.some((r) => r.roleName === 'APPROVER');

  const menuItems = [
    { path: '/dashboard', icon: <FaHome />, labelKey: 'sidebar.dashboard', approverOnly: false },
    { path: '/timesheets', icon: <FaClock />, labelKey: 'sidebar.timesheets', approverOnly: false },
    { path: '/expenses', icon: <FaMoneyBill />, labelKey: 'sidebar.expenses', approverOnly: false },
    { path: '/approvals', icon: <FaClipboardCheck />, labelKey: 'sidebar.approvals', approverOnly: true },
    { path: '/documents', icon: <FaFileAlt />, labelKey: 'sidebar.documents', approverOnly: false },
    { path: '/settings', icon: <FaCog />, labelKey: 'sidebar.settings', approverOnly: false },
    { path: '/help', icon: <FaQuestionCircle />, labelKey: 'sidebar.help', approverOnly: false },
  ];

  useEffect(() => {
    close();
  }, [location.pathname, close]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        close();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, close]);

  return (
    <>
      {isOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label={t('navbar.closeMenu')}
          onClick={close}
        />
      )}
      <aside className={`sidebar-container ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-logo">
          <img src={timesheetLogo} alt="EZ Timesheet Logo" className="sidebar-logo-image" />
          <span>EZ Timesheet</span>
        </div>
        <nav className="sidebar-nav-list">
          {menuItems.map((item) =>
            (!item.approverOnly || isApprover) && (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `sidebar-nav-item ${isActive ? 'active' : ''}`
                }
                onClick={close}
              >
                {item.icon}
                {t(item.labelKey)}
              </NavLink>
            )
          )}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
